namespace PaperTrail.NewsletterControl {
    export interface NewsletterAdvertisementRow {
        NewsletterAdvertisementId?: number;
        NewsletterId?: number;
        AdvertisementId?: number;
        NewsletterNewsletterName?: string;
        NewsletterCreatedBy?: number;
        NewsletterDateCreated?: string;
        NewsletterDateModified?: string;
        NewsletterModifiedBy?: number;
        NewsletterPageCount?: number;
        NewsletterStyleSheetId?: number;
        AdvertisementContent?: string;
        AdvertisementUrl?: string;
        AdvertisementImageBytes?: number[];
        AdvertisementTitle?: string;
        AdvertisementSubtitle?: string;
    }

    export namespace NewsletterAdvertisementRow {
        export const idProperty = 'NewsletterAdvertisementId';
        export const localTextPrefix = 'NewsletterControl.NewsletterAdvertisement';
        export const deletePermission = 'Newsletter:Contributor';
        export const insertPermission = 'Newsletter:Contributor';
        export const readPermission = 'Newsletter:Contributor';
        export const updatePermission = 'Newsletter:Contributor';

        export declare const enum Fields {
            NewsletterAdvertisementId = "NewsletterAdvertisementId",
            NewsletterId = "NewsletterId",
            AdvertisementId = "AdvertisementId",
            NewsletterNewsletterName = "NewsletterNewsletterName",
            NewsletterCreatedBy = "NewsletterCreatedBy",
            NewsletterDateCreated = "NewsletterDateCreated",
            NewsletterDateModified = "NewsletterDateModified",
            NewsletterModifiedBy = "NewsletterModifiedBy",
            NewsletterPageCount = "NewsletterPageCount",
            NewsletterStyleSheetId = "NewsletterStyleSheetId",
            AdvertisementContent = "AdvertisementContent",
            AdvertisementUrl = "AdvertisementUrl",
            AdvertisementImageBytes = "AdvertisementImageBytes",
            AdvertisementTitle = "AdvertisementTitle",
            AdvertisementSubtitle = "AdvertisementSubtitle"
        }
    }
}
